﻿import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/pg_franquia/franquia-analises-avisos";

export const Route = createFileRoute("/_authenticated/avisos")({
  head: () => ({
    meta: [
      { title: "Avisos de inconsistência — Milky Moo Palmares" },
      {
        name: "description",
        content: "Inconsistências detectadas automaticamente nos cadastros do controle de estoque.",
      },
      { property: "og:title", content: "Avisos de inconsistência — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Inconsistências detectadas automaticamente nos cadastros do controle de estoque.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
